<script setup lang="ts">
import { priceRange } from "~/constants/plan";
import { useScroll } from "@vueuse/core";
const route = useRoute();
const selectedRange = computed(() => {
  return route.query.range ? parseInt(route.query.range.toString()) : 0;
});

const priceLinks = ref<HTMLElement[] | null>();
const wrapper = ref<HTMLElement | null>();

const { x, arrivedState } = useScroll(wrapper, { behavior: "smooth" });

onMounted(() => {
  if (priceLinks.value && priceLinks.value.length) {
    const el = priceLinks.value[selectedRange.value - 1];
    if (el) {
      el.scrollIntoView({
        behavior: "instant",
        inline: "center",
      });
    }
  }
});
</script>

<template>
  <div class="w-full relative pr-6 select-none">
    <div
      v-if="!arrivedState.left"
      class="absolute left-0 top-0 controller"
      aria-label="scroll left"
      @click="x -= 300"
    >
      <Icon name="mdi:chevron-left" />
    </div>
    <ul ref="wrapper" class="list">
      <li
        class="rounded-lg p-2 whitespace-nowrap"
        :class="
          selectedRange != 0 ? 'bg-gray-100 ' : 'bg-famitei-green text-white'
        "
      >
        <NuxtLink
          :to="{
            path: '/plan',
            query: { ...route.query, range: 0, off: 0 },
          }"
        >
          <span class="text-center align-middle">すべての価格</span>
        </NuxtLink>
      </li>
      <li
        v-for="(price, idx) in priceRange"
        :key="idx"
        ref="priceLinks"
        class="rounded-lg p-2 whitespace-nowrap"
        :class="
          selectedRange != price.id
            ? 'bg-gray-100 '
            : 'bg-famitei-green text-white'
        "
      >
        <NuxtLink
          class="aspect-square w-fit"
          :to="{
            path: '/plan',
            query: { ...route.query, range: price.id, off: 0 },
          }"
        >
          <p class="text-xs">
            <span>￥</span>
            <span v-if="price.from && !price.to" class="text-xl font-bold">{{
              price.from
            }}</span>
            <span v-if="price.to">~</span>
            <span v-if="price.to" class="text-xl font-bold">{{
              price.to
            }}</span>
            <span>万</span>
            <span v-if="!price.to">以上</span>
          </p>
        </NuxtLink>
      </li>
    </ul>
    <div
      v-if="!arrivedState.right"
      class="absolute right-0 top-0 controller"
      aria-label="scroll right"
      @click="x += 300"
    >
      <Icon name="mdi:chevron-right" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.list {
  @apply w-full flex gap-4 overflow-x-scroll rounded;

  /* Firefox 対応 */
  scrollbar-width: none;
  // Chrome・Safari・Microsoft Edge 以前
  -ms-overflow-style: none;
  // Chrome・Safari・Microsoft Edge 上が効かない最近のバージョン
  &::-webkit-scrollbar {
    display: none;
  }
}

.controller {
  @apply bg-gray-300 z-10 hover:bg-gray-500 hover:text-white cursor-pointer w-6 h-full flex justify-center items-center rounded;
}
</style>
